import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const AileBirlesmesiPage = () => {
  useEffect(() => {
    document.title = 'Aile Birleşimi Vizesi | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Aile birleşimi vize başvuruları. Eş, çocuk ve aile üyeleri için göçmenlik süreçlerinde profesyonel danışmanlık hizmeti.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/99bd53203c50b94b76b57fa9d412fe49.jpg"
              alt="Aile Birleşimi"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              Göçmenlik Hizmeti
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Aile Birleşimi Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Sevdiklerinizle yurt dışında bir araya gelmeniz için profesyonel destek
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Aile Birleşimi Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Aile birleşimi, yurt dışında yasal olarak ikamet eden bir kişinin, aile üyelerini (eş, çocuklar, bazen ebeveynler) yanına getirmesi için yapılan göçmenlik başvurusudur. Bu süreç, ailelerin bir arada yaşama hakkını korumayı amaçlayan uluslararası bir haktır ve çoğu ülke tarafından tanınmaktadır.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                Aile birleşimi başvuruları, her ülkenin kendi göçmenlik yasalarına göre değişiklik gösterir. Süreç genellikle karmaşık ve uzun sürelidir, ancak doğru hazırlık ve profesyonel danışmanlık ile başarı şansı önemli ölçüde artar. Başvuru sahibinin (sponsor) ve katılacak aile üyelerinin belirli kriterleri karşılaması gerekmektedir.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Kimler Aile Birleşimi Başvurusu Yapabilir?
              </h2>
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-user-heart-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Sponsor (Davet Eden)</h3>
                  <p className="text-cream-200 text-sm mb-3">Hedef ülkede yasal olarak ikamet eden kişi. Aşağıdaki statülerden birine sahip olmalıdır:</p>
                  <ul className="text-cream-200 text-sm space-y-1">
                    <li>• Vatandaş</li>
                    <li>• Kalıcı oturum izni sahibi</li>
                    <li>• Uzun süreli oturum izni sahibi</li>
                    <li>• Mülteci statüsü sahibi</li>
                  </ul>
                </div>
                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-group-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Katılacak Aile Üyeleri</h3>
                  <p className="text-navy-700 text-sm mb-3">Genellikle aşağıdaki aile üyeleri başvurabilir:</p>
                  <ul className="text-navy-700 text-sm space-y-1">
                    <li>• Eş (evli veya kayıtlı partner)</li>
                    <li>• 18 yaş altı çocuklar</li>
                    <li>• Bağımlı yetişkin çocuklar</li>
                    <li>• Ebeveynler (bazı ülkelerde)</li>
                  </ul>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Aile Birleşimi Türleri
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-heart-fill text-2xl text-navy-900 mr-3"></i>
                    Eş Birleşimi
                  </h3>
                  <p className="text-navy-600 text-sm mb-3">
                    Yasal evlilik veya kayıtlı ortaklık durumunda eşin yanına gitme hakkı. En yaygın aile birleşimi türüdür.
                  </p>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-navy-700 text-sm"><strong>Gereksinimler:</strong></p>
                    <ul className="text-navy-600 text-sm space-y-1 mt-2">
                      <li>• Geçerli evlilik belgesi (apostilli ve tercümeli)</li>
                      <li>• Sponsorun yeterli gelir belgesi</li>
                      <li>• Konaklama belgesi</li>
                      <li>• İlişkinin gerçekliğini gösteren kanıtlar</li>
                    </ul>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-parent-line text-2xl text-navy-900 mr-3"></i>
                    Çocuk Birleşimi
                  </h3>
                  <p className="text-navy-600 text-sm mb-3">
                    18 yaş altı veya bağımlı çocukların ebeveynlerinin yanına gitme hakkı.
                  </p>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-navy-700 text-sm"><strong>Gereksinimler:</strong></p>
                    <ul className="text-navy-600 text-sm space-y-1 mt-2">
                      <li>• Doğum belgesi (apostilli ve tercümeli)</li>
                      <li>• Velayet belgesi (gerekirse)</li>
                      <li>• Diğer ebeveynin onayı (gerekirse)</li>
                      <li>• Sponsorun mali yeterlilik belgesi</li>
                    </ul>
                  </div>
                </div>

                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-user-2-line text-2xl text-navy-900 mr-3"></i>
                    Ebeveyn Birleşimi
                  </h3>
                  <p className="text-navy-600 text-sm mb-3">
                    Bazı ülkelerde, belirli koşullar altında ebeveynlerin çocuklarının yanına gitme hakkı.
                  </p>
                  <div className="bg-white rounded-lg p-4">
                    <p className="text-navy-700 text-sm"><strong>Gereksinimler:</strong></p>
                    <ul className="text-navy-600 text-sm space-y-1 mt-2">
                      <li>• Ebeveynin bağımlı olduğunun kanıtı</li>
                      <li>• Sponsorun yüksek gelir belgesi</li>
                      <li>• Ebeveynin Türkiye'de bakım alamayacağının kanıtı</li>
                      <li>• Sağlık sigortası</li>
                    </ul>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Uygunluk Değerlendirmesi</h3>
                      <p className="text-cream-200">Sponsorun ve katılacak aile üyelerinin uygunluğu detaylı şekilde değerlendirilir. Hedef ülkenin gereksinimleri analiz edilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Toplama ve Hazırlık</h3>
                      <p className="text-navy-700">Tüm gerekli belgeler toplanır, apostil işlemleri yapılır, noter onaylı tercümeler hazırlanır.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-800 to-navy-700 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Başvuru Dosyası Hazırlama</h3>
                      <p className="text-cream-200">Tüm belgeler organize edilir ve başvuru formu eksiksiz şekilde doldurulur.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-300 to-cream-200 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Başvuru Yapılması</h3>
                      <p className="text-navy-700">Başvuru ilgili konsolosluk veya göçmenlik ofisine yapılır. Randevu alınır ve biyometrik veriler kaydedilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Değerlendirme Süreci</h3>
                      <p className="text-cream-200">Göçmenlik makamları başvuruyu inceler. Bu süre 3-12 ay arasında değişebilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">6</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Vize/Oturum İzni Alımı</h3>
                      <p className="text-navy-700">Başvuru onaylandıktan sonra aile üyeleri vize veya oturum izni alır ve ülkeye giriş yapabilir.</p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Genel Gerekli Evraklar
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <h3 className="font-bold text-cream-100 text-xl mb-4">Sponsor (Davet Eden) İçin</h3>
                <ul className="space-y-3 text-cream-100 mb-6">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Pasaport veya kimlik belgesi kopyası</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Oturum izni veya vatandaşlık belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Gelir belgesi (maaş bordrosu, vergi beyannamesi)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">İş sözleşmesi veya çalışma belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Konaklama belgesi (kira sözleşmesi veya tapu)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Davetiye mektubu</span>
                  </li>
                </ul>

                <h3 className="font-bold text-cream-100 text-xl mb-4">Katılacak Aile Üyeleri İçin</h3>
                <ul className="space-y-3 text-cream-100">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Geçerli pasaport</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Evlilik cüzdanı veya doğum belgesi (apostilli ve tercümeli)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Nüfus kayıt örneği</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Sabıka kaydı belgesi (apostilli)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Sağlık sigortası</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Biyometrik fotoğraflar</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">İlişkiyi kanıtlayan belgeler (fotoğraflar, haberleşme kayıtları vb.)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Dil yeterlilik belgesi (bazı ülkeler için)</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Önemli Dikkat Edilmesi Gerekenler
              </h2>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-money-euro-circle-line text-2xl text-navy-900 mr-2"></i>
                    Mali Yeterlilik
                  </h3>
                  <p className="text-navy-600 text-sm">Sponsorun, aile üyelerini destekleyebilecek yeterli gelire sahip olması kritik önem taşır. Her ülkenin minimum gelir gereksinimleri farklıdır.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-home-4-line text-2xl text-navy-900 mr-2"></i>
                    Uygun Konaklama
                  </h3>
                  <p className="text-navy-600 text-sm">Aile üyelerinin kalabileceği yeterli büyüklükte bir konut olmalıdır. Kira sözleşmesi veya tapu belgesi gereklidir.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-file-shield-2-line text-2xl text-navy-900 mr-2"></i>
                    İlişkinin Gerçekliği
                  </h3>
                  <p className="text-navy-600 text-sm">Özellikle eş birleşiminde, ilişkinin gerçek olduğunu kanıtlayan belgeler çok önemlidir. Sahte evlilik şüphesi başvurunun reddine neden olur.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <h3 className="font-bold text-navy-900 text-lg mb-3 flex items-center">
                    <i className="ri-time-line text-2xl text-navy-900 mr-2"></i>
                    Süreç Süresi
                  </h3>
                  <p className="text-navy-600 text-sm">Aile birleşimi başvuruları uzun sürebilir. Sabırlı olmak ve düzenli takip yapmak önemlidir. Ortalama süre 6-12 ay arasındadır.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel Danışmanlık Avantajları
              </h2>
              <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6 md:p-8 mb-8">
                <ul className="space-y-3 text-navy-900">
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Uygunluk Analizi:</strong> Başvuru öncesi detaylı uygunluk değerlendirmesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Evrak Yönetimi:</strong> Tüm belgelerin eksiksiz ve doğru hazırlanması</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Apostil ve Tercüme:</strong> Tüm resmi işlemlerin koordinasyonu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Başvuru Takibi:</strong> Sürecin her aşamasında bilgilendirme</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Hata Minimizasyonu:</strong> Ret riskini azaltan profesyonel hazırlık</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-shield-check-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg"><strong>Zaman Tasarrufu:</strong> Karmaşık süreçlerin sizin adınıza yönetilmesi</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Aile birleşimi başvurusu ne kadar sürer?</h3>
                  <p className="text-navy-600">Ülkeye ve başvuru türüne göre 6-12 ay arasında değişir. Bazı ülkelerde daha hızlı, bazılarında daha uzun sürebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Sponsorun ne kadar geliri olmalı?</h3>
                  <p className="text-navy-600">Her ülkenin farklı gereksinimleri vardır. Genellikle asgari ücretin 1.5-2 katı gelir beklenir. Aile üyesi sayısına göre artar.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Başvuru reddedilirse ne olur?</h3>
                  <p className="text-navy-600">Ret nedenleri analiz edilerek eksiklikler giderildikten sonra yeniden başvuru yapılabilir. İtiraz hakkı da bulunmaktadır.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Aile üyeleri çalışabilir mi?</h3>
                  <p className="text-navy-600">Çoğu ülkede aile birleşimi vizesi ile çalışma hakkı verilir, ancak bazı ülkelerde ayrı çalışma izni gerekebilir.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              Aile Birleşimi Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              Sevdiklerinizle bir araya gelmek için profesyonel destek alın
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default AileBirlesmesiPage;